import { Route, Routes } from "react-router-dom";
import {
  OzonetelStages,
  NurturePayDetails,
  Edufin,
  EdufinDetailsComponent,
} from "../pages";
import React from "react";
import OzonetelDetails from "../pages/app/Integrations/components/OzonetelDetails/OzonetelDetails";
import AgentsListing from "../pages/app/Integrations/components/OzonetelDetails/AgentsListing/AgentsListing";
import NurturePayStages from "../pages/app/Integrations/components/NurturePayDetail/NurturePayStages";
import ZapierDetails from "../pages/app/Integrations/components/Zapier/ZapierDetails";
import ZapierIntegration from "../pages/app/Integrations/components/Zapier/ZapierIntegration";
import MetaIntegration from "../pages/app/Integrations/components/Meta/MetaIntegration";
import EdufinDetails from "../pages/app/Integrations/components/EdufinDetails/EdufinDetails";
import DraftSavedEdufinBranchesList from "../pages/app/Integrations/components/EdufinDetails/DraftSavedEdufinBranchesList";

export default function ManageIntegrationRouter(props: any) {
  return (
    <Routes>
      <Route path={"/OzonetelDetails"} element={<OzonetelDetails />} />
      <Route path={"/OzonetelStages"} element={<OzonetelStages />} />
      <Route
        path={"/OzonetelStages/AgentsListing"}
        element={<AgentsListing />}
      />
      <Route path={"/NurturePayDetails"} element={<NurturePayDetails />} />
      <Route path={"/NurturePayStages"} element={<NurturePayStages />} />
      <Route path={"/ZapierDetails"} element={<ZapierDetails />} />
      <Route path={"/ZapierIntegration"} element={<ZapierIntegration />} />
      <Route path={"/MetaIntegration"} element={<MetaIntegration />} />
      <Route path={"/EdufinDetails/*"} element={<EdufinDetailsComponent />} />
      <Route
        path={"/EdufinDetails/EdufinDetailsForDraftState"}
        element={<Edufin />}
      />
    </Routes>
  );
}
